import { render } from "./ClasificationForm.vue?vue&type=template&id=ab481d3c&scoped=true"
import script from "./ClasificationForm.vue?vue&type=script&lang=js"
export * from "./ClasificationForm.vue?vue&type=script&lang=js"

import "./ClasificationForm.vue?vue&type=style&index=0&id=ab481d3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab481d3c"]])

export default __exports__